const SCALAR_FIELD_KEYS = ['title', 'description', 'flag', 'color', 'rating'];
const LIST_FIELD_KEYS = ['keywords', 'assignees'];

function isNonEmptyValue(value) {
  if (value === undefined || value === null || value === false || value === '') return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;
  return true;
}

function serializeComment(comment) {
  return typeof comment === 'string' ? comment : '';
}

function isDirtyScalarValue(key, value) {
  if (key === 'rating' && value === 0) return false;
  return isNonEmptyValue(value);
}

function areValuesEqual(left, right) {
  if (Object.is(left, right)) return true;
  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return false;
    return left.every((value, index) => areValuesEqual(value, right[index]));
  }
  if (left && right && typeof left === 'object' && typeof right === 'object') {
    const leftKeys = Object.keys(left).sort();
    const rightKeys = Object.keys(right).sort();
    return leftKeys.length === rightKeys.length
      && leftKeys.every((key, index) => (
        key === rightKeys[index] && areValuesEqual(left[key], right[key])
      ));
  }
  return false;
}

function getAddedEntries(currentEntries = [], snapshotEntries = []) {
  const snapshotIds = new Set(snapshotEntries.map(({ _id }) => String(_id)));
  const addedIds = new Set();

  return currentEntries.filter(({ _id }) => {
    const id = String(_id);
    if (snapshotIds.has(id) || addedIds.has(id)) return false;
    addedIds.add(id);
    return true;
  });
}

export default function deriveKeepRevisionFields(currentFields = {}, snapshot = {}) {
  const changedFields = {
    comment: serializeComment(currentFields.comment),
  };

  SCALAR_FIELD_KEYS.forEach((key) => {
    const value = currentFields[key];
    if (isDirtyScalarValue(key, value) && !areValuesEqual(value, snapshot[key])) {
      changedFields[key] = value;
    }
  });

  LIST_FIELD_KEYS.forEach((key) => {
    const addedEntries = getAddedEntries(currentFields[key], snapshot[key]);
    if (addedEntries.length) changedFields[key] = addedEntries;
  });

  const currentCustomFields = currentFields.customFields || {};
  const snapshotCustomFields = snapshot.customFields || {};
  const changedCustomFields = Object.entries(currentCustomFields).reduce(
    (result, [title, field]) => {
      const value = field?.value;
      if (
        !isNonEmptyValue(value)
        || areValuesEqual(value, snapshotCustomFields[title]?.value)
      ) {
        return result;
      }
      return { ...result, [title]: field };
    },
    {},
  );

  if (Object.keys(changedCustomFields).length) {
    changedFields.customFields = changedCustomFields;
  }

  return changedFields;
}
